import { StaticLayer, LayerCategory, LayerSet } from '../types/static-layers.types';
import { ukhabLayerSet } from '../configs/layers/ukhab-layers.config';
import { store } from '../store/stencil-redux';
import { safelyAddSource } from './maps/maps.utils';
import * as mapboxgl from 'mapbox-gl/esm';

export class StaticLayersRegistry {
  private static _instance: StaticLayersRegistry;
  private layerSets: LayerSet[] = [
    ukhabLayerSet
  ];
  private enabledSets: LayerSet[] = [];

  private constructor() { }

  static get instance(): StaticLayersRegistry {
    if (!StaticLayersRegistry._instance) {
      StaticLayersRegistry._instance = new StaticLayersRegistry();
    }
    return StaticLayersRegistry._instance;
  }

  public addTo(map: mapboxgl.Map): void {
    const sources = this.getActiveSources();
    for(const [sourceId, sourceConfig] of sources) {
      safelyAddSource(map, sourceId, sourceConfig);
    }
  }

  updateEnabledSets(): void {
    const state = store.getState();
    this.enabledSets = this.layerSets.filter(set =>
      !set.isEnabled || set.isEnabled(state)
    );
  }

  getEnabledLayers(): StaticLayer[] {
    return this.enabledSets.flatMap(set => set.layers);
  }

  getEnabledCategories(): LayerCategory[] {
    return this.enabledSets.flatMap(set => set.categories);
  }

  getActiveSources(): Array<[string, any]> {
    return this.enabledSets.flatMap(set =>
      Object.entries(set.sources)
    );
  }

  getLayerById(id: string): StaticLayer | null {
    for (const set of this.enabledSets) {
      const layer = set.layers.find(l => l.id === id);
      if (layer) {
        return layer;
      }
    }
    for (const set of this.layerSets) {
      const layer = set.layers.find(l => l.id === id);
      if (layer) {
        return layer;
      }
    }
    return null;
  }
}